import React from 'react';
import Pnavbar from '../components/JSX/Pnavbar';
import Slider6 from '../components/JSX/Slider6';
import Comp from '../components/JSX/Comprehension';
import Footerp1 from '../components/JSX/Footerp1';

const National = () => (
  <>
    <Pnavbar />
    <Slider6 />
    <Comp/>
    <Footerp1/>
  </>
);

export default National